<template>
  <div class="warp" v-loading="loading">
    <div class="warp-content">
      <div class="left">
        <div class="chunk-title">业主
          <el-select style="width:168px" size="small" v-model="proprietorIndex" @change="proprietorChange">
            <el-option v-for="(item,index) in tableData" :key="index" :value="index" :label="item.name"></el-option>
          </el-select>
        </div>
        <div class="flex-1">
          <el-tree ref="tree" highlight-current :data="treeAreaData" node-key="id" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </div>
      </div>
      <div class="right">
        <div class="chunk-title">场地开关列表</div>
        <div class="flex-1">
          <div class="list">
            <div class="item" v-for="(item,index) in switchData" :key="index">
              <div class="flex">
                <div class="flex-60">开关编号:</div>
                <div class="flex-1">
                  <div class="break-space">{{item.id}}</div>
                </div>
              </div>
              <div class="flex">
                <div class="flex-60">开关名称:</div>
                <div class="flex-1">
                  <div class="break-space">{{item.name}}</div>
                </div>
              </div>
              <div class="flex">
                <div class="flex-60">开关状态:</div>
                <div class="flex-1">
                  <div class="break-space">
                    <el-switch v-if="item.state" v-model="item.state" active-color="#13ce66" :active-value="1" :inactive-value="0" inactive-color="#ff4949" @change="switchChange(item)">
                    </el-switch>
                    <label v-else>暂无开关状态</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@common/api/index.js'
import utils from '@common/utils/index.js'
import socket from "@/utils/websocket.js";
export default {
  data () {
    return {
      tableData: [],
      proprietorIndex: 0,
      treeAreaData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      selectedArea: null,
      switchData: [],
      socket: null,
      loading: false
    }
  },
  created () {
    this.getRentalArea()
  },
  methods: {
    getRentalArea () {
      api.rentalArea.getRentalAreaTrusteeshipContractForProperty(null, null, null, null, null, null, 1).then(res => {
        if (res.data) {
          let tableData = []
          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            let proprietorIndex = tableData.findIndex(c => c.id === element.proprietorCompanyId)
            if (proprietorIndex == -1) {
              tableData.push({ id: element.proprietorCompanyId, name: element.proprietorCompanyName, children: [] })
              proprietorIndex = tableData.length - 1
            }
            for (let j = 0; j < element.areas.length; j++) {
              const area = element.areas[j];
              let areaIndex = tableData[proprietorIndex].children.findIndex(c => c.id === area.id)
              if (areaIndex == -1) {
                tableData[proprietorIndex].children.push(area)
              }
            }
          }
          this.tableData = tableData
          this.proprietorChange(0)
        }
        else {
          this.tableData = []
          this.selectedArea = null
          this.switchData = []
        }
      })
    },
    proprietorChange (val) {
      let areasId = []
      for (let i = 0; i < this.tableData[val].children.length; i++) {
        areasId.push(this.tableData[val].children[i].id)
      }

      api.rentalArea.getSubRentalAreas(areasId, 1).then(res => {
        if (res && res.data) {
          this.treeAreaData = utils.companyDataToCompanyTree(res.data)
          if (this.treeAreaData.length > 0) {
            this.selectedArea = this.treeAreaData[0]
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(this.selectedArea.id)
            })
            this.getRentalAreaSwitches()
          }
          else {
            this.treeAreaData = []
            this.selectedArea = null
          }
        }
      })
      // this.treeAreaData = this.tableData[val].children
      // if (this.treeAreaData.length > 0) {
      //   this.selectedArea = this.treeAreaData[0]
      //   this.$nextTick(() => {
      //     this.$refs.tree.setCurrentKey(this.selectedArea.id)
      //   })
      //   this.getRentalAreaSwitches()
      // }
      // else {
      //   this.treeAreaData = []
      //   this.selectedArea = null
      // }
    },
    handleNodeClick (data, nodde, el) {
      this.selectedArea = data
      this.getRentalAreaSwitches()
    },
    getRentalAreaSwitches () {
      api.rentalArea.getRentalAreaSwitches(this.selectedArea.id).then(res => {
        if (res.data) {
          // this.switchData = 
          let switchData = res.data
          let apiArr = []
          for (let i = 0; i < switchData.length; i++) {
            apiArr.push(api.rentalArea.getRentalAreaSwitchMeasureBindings(switchData[i].id))
          }

          Promise.all(apiArr).then(resArr => {
            for (let i = 0; i < resArr.length; i++) {
              const res = resArr[i];
              if (res.data) {
                // 查出结束时间为  null 的测量点
                const item = res.data.find(c => c.endTime === null)
                let measureId = null
                if (item) {
                  measureId = item.measureId
                }
                switchData[i].measureId = measureId
                switchData[i].state = null

              }
            }

            this.switchData = switchData
            // 获取数据推送链接

          })
        }
        else {
          this.switchData = []
        }
      })
    },
    allotMeasuringRealtimeNotifyServer () {
      api.measuringServer.allotMeasuringRealtimeNotifyServer().then(res => {
        if (res.data) {

          let agentData = {
            methodCode: "101",
            key: res.data.key,
          };

          this.socket = new socket({
            //网址（端口是我下面的服务器的端口）
            url:
              window.baseConfig.wsAgreement + "://" + res.data.ip + ":" + res.data.port + "/" + res.data.path,
          });


          this.socket.onopen((event) => {
            this.socket.send(agentData);
          });
          //接收信息
          this.socket.onmessage((data) => {
            this.webSockMsg(JSON.parse(data));
          });

        }
      })
    },
    webSockMsg (e) {
      let vm = this;
      if (e.methodCode == "102") {
        let measures = []
        for (let i = 0; i < this.switchData.length; i++) {
          measures.push({
            id: this.switchData[i].measureId,
            points: [{ code: '601', number: '0' }]
          })
        }
        vm.socket.send({
          methodCode: "103",
          measures: measures
        });
      }
      else if (e.methodCode == '105') {
        for (let i = 0; i < e.data.length; i++) {
          for (let j = 0; j < this.switchData.length; j++) {
            if (this.switchData[j].measureId == e.data[i].measureId) {
              this.switchData[j].state = e.data[i][0].value
            }
          }
        }
      }
    },

    switchChange (item) {
      let value = "ON"
      if (item.switch !== 1) {
        value = "OFF"
      }
      this.loading = true
      api.command.executeCommandOnMeasure(item.measureId, 'Switch', JSON.stringify([{ "ON-OFF": value }])).then(res => {
        if (res.data) {
          this.loading = false
          this.$message(res.data)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  .warp-content {
    width: 100%;
    height: 100%;
    padding: 10px;
    background: #fff;
    color: #2e3842;
    text-align: left;
    box-sizing: border-box;
    display: flex;
    .left {
      flex: 0 0 200px;
      overflow: auto;
      display: flex;
      flex-flow: column;
    }
    .right {
      margin-left: 10px;
      flex: 1;
      display: flex;
      flex-flow: column;
      .list {
        width: 100%;
        height: 100%;
        overflow: auto;
        .item {
          width: 240px;
          height: 100px;
          border-radius: 4px;
          border: 1px solid #eee;
          float: left;
          margin-right: 10px;
          margin-bottom: 10px;
          .btn {
            height: 30px;
            background: #eee;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            border-radius: 0px 0px 4px 4px;
            &:hover {
              background: #409eff;
              color: #fff;
            }
          }
        }
      }
    }
    .chunk-title {
      flex: 0 0 30px;
      line-height: 30px;
      margin-bottom: 10px;
    }
    .flex-1 {
      flex: 1;
      overflow: auto;
    }
    .flex {
      display: flex;
      align-items: center;
      height: 30px;
    }
    .flex-60 {
      flex: 0 0 70px;
      text-align: right;
    }
    .break-space {
      width: 100%;
      overflow: hidden;
      white-space: break-spaces;
    }
  }
}
</style>